import { Component } from '@angular/core';
import BaseDetailPageConfig from '../../../../models/base-detail-page.config';
import { JurisdictionsService } from '../../../../services/api/general-settings/jurisdictions.service';
import { BaseDetailPageComponent } from '../../../../components/pages/base-detail-page/base-detail-page.component';
import { RouteService } from '../../../../services/route.service';

@Component({
  selector: 'app-jurisdiction-detail-page',
  imports: [BaseDetailPageComponent],
  templateUrl: './jurisdiction-detail-page.component.html',
  styleUrl: './jurisdiction-detail-page.component.scss'
})
export class JurisdictionDetailPageComponent {
 baseDetailPageConfig!: BaseDetailPageConfig;
  readonlyUserDetail:boolean

  jurisdiction?: any;

  constructor(
    private jurisdictionsService: JurisdictionsService,
    private routeService: RouteService
  ) {
    this.readonlyUserDetail = true
  }

  ngOnInit(): void {

    this.baseDetailPageConfig = {
      pageTitle: 'Jurisdictions',
      cardTitle: 'Jurisdiction Detail',
      editItemButton: {
        type: 'success',
        title: 'Edit Jurisdiction',
        onClick: () => {
          this.routeService.jurisdictionUpdate(this.jurisdiction?.jurisdictionId)
        }
      },
      dataList: {
        data: null,
        rows: [
          {
            attribute: 'jurisdictionId',
            label: 'Jurisdiction Id',
            value: (item: any) => {
              return item.jurisdictionId;
            }
          },
          {
            attribute: 'code',
            label: 'Code',
            value: (item: any) => {
              return item.code;
            }
          },
          {
            attribute: 'name',
            label: 'Name',
            value: (item: any) => {
              return item.name;
            }
          },        
          {
            attribute: 'Language',
            label: 'Language',
            value: (item: any) => {
              return item.language.name;
            }
          },     
          {
            attribute: 'createTime',
            label: 'Create Time',
            value: (item: any) => {
              return item.createTime;
            }
          },
        ]
      },
      apiDetailService: (jurisdictionId: number) => this.jurisdictionsService.detail(jurisdictionId),
      routeParamName: 'jurisdictionId',
      responseModelName: 'jurisdiction'
    };

  }

  onLoadedDetail(data: any) {
    this.jurisdiction = data;
  }
}
